export interface Props extends PropsCommon {
	/**
	 * Статус загрузки страницы диалогового окна
	 *
	 * При включении взаимодействие со страницей блокируется, отображается анимация загрузки
	 */
	isLoading?: boolean;
}

/**
 * Общие props для компонентов реализуюущих TopDialogPage
 */
export interface PropsCommon {
	/**
	 * Имя страницы для диалогового окна
	 *
	 * Имя страницы нужно для навигации между страницами в одном диалоговом окне
	 */
	name: string,

	/**
	 * Порядкой номер страницы в диалоговом окне
	 *
	 * Одна и та же страница может быть подключена в разные диалоговые окна и иметь разный порядковый номер
	 */
	order: number,

	/**
	 * Имя предыдущей страницы
	 *
	 * Для кнопки Назад / Закрыть в мобильной версии
	 */
	prevName?: string,

	/**
	 * Стиль отображения футера, при котороым элементы растягиваются на всю ширину
	 *
	 * Разрешены переносы
	 */
	footerFullWith?: boolean,
}

/**
 * Общие props для компонентов реализуюущих TopDialogPage
 *
 * Для не SFC компонентов
 */
export const propsPageCommon = {
	name: {
		type: String,
		required: true,
	},

	order: {
		type: Number,
		required: true,
	},

	prevName: String,

	footerFullWith: Boolean,
};

export interface Slots {
	/**
	 * Шапка страницы
	 */
	header(props: {}): any;

	/**
	 * Кнопки для шапки страницы
	 */
	headerButtons?(props: {}): any;

	/**
	 * Контент страницы
	 */
	body(props: {}): any;

	/**
	 * Футер страницы
	 */
	footer?(props: {}): any;
}
